export default __webpack_public_path__ + "static/media/CystoConsent.86825573.pdf";